<template>
  <v-container fluid>
    <Navbar />
      <v-card>
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>
          Verificando Pago, por favor espera...
        </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import api from '@/plugins/api'

export default {
  name: 'PaymentMessage',
  components: {
    Navbar
  },
  data () {
    return {
      titulo: 'Pago',
      dialog: false,
      status: this.status,
      id: this.$route.params.id,
      inputs: [
        {
          name: ''
        }
      ],
      documentos: [],
      firmantes: [
      ],
      documento: []
    }
  },
  mounted () {
    this.getTodos(this.$route.params.id)
  },
  methods: {
    async getDatos (id) {
      try {
        const response = await api.get(`formulario/${id}`)
        this.formData = response.data.form
        console.log(response)
      } catch (error) {
        alert('Error al hacer get' + error)
        console.log('Error al hacer get' + error)
      }
    },
    async postDatos (id) {
      try {
        /* const response = await api.post(`crear/${id}`, {
          formulario: this.datos[0],
          firmantes: this.firmantes
        })
        console.log(response)
        const tramiteId = response.data.tramiteId */
        // localStorage.setItem('info_doc', JSON.stringify({ formulario: this.datos[0], firmantes: this.firmantes }))
        this.$router.push(`/Boleta/${id}`)
      } catch (error) {
        this.alertRut = true
        console.log('Error al eviar post' + error)
      }
    }
  }
}
</script>
